/**
 * Lead List Page
 * ==============
 * Main page for viewing and managing leads
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui';
import { DashboardLayout } from '../../components/layout';
import { LeadList } from '../../components/leads';
import { usePermissions } from '../../hooks';

const LeadListPage = () => {
  const navigate = useNavigate();
  const [refreshTrigger] = useState(0);
  const { is } = usePermissions();
  const canCreateLead = !is.viewer() && !is.complianceOfficer();

  const handleCreateLead = () => {
    navigate('/leads/create');
  };

  const handleLeadSelect = (leadId) => {
    navigate(`/leads/${leadId}`);
  };

  return (
    <DashboardLayout>
      <div className="max-w-7xl mx-auto">
        {/* Page Header */}
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-2xl sm:text-[28px] font-sans font-bold text-gray-900 dark:text-white mb-2">
              Lead Management
            </h1>
            <p className="text-gray-500 dark:text-gray-400">
              AI-powered lead research, discovery questionnaires, and engagement tracking
            </p>
          </div>
          {canCreateLead && (
            <Button variant="primary" onClick={handleCreateLead} className="w-full sm:w-auto flex-shrink-0 justify-center">
              <svg
                className="w-5 h-5 mr-2 inline"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4v16m8-8H4"
                />
              </svg>
              Create Lead
            </Button>
          )}
        </div>

        {/* Lead List */}
        <LeadList onLeadSelect={handleLeadSelect} refreshTrigger={refreshTrigger} />
      </div>
    </DashboardLayout>
  );
};

export default LeadListPage;

